import { get, post } from './api';
import { report, reportEvent, user } from './schema';
import * as Api from './v2';

export const getReportsCategories = () => get(`/v1/report_categories`);
export const getReport = id => get(`/v1/reports/${id}`, { schema: report });
export const getReportWitnesses = id => get(`/v1/reports/${id}/witness`, { schema: [user] });
export const getReportEvents = id => get(`/v1/reports/${id}/events`);
export const getReportComments = id => get(`/v1/reports/${id}/comments`);
export const getPlaceReports = id => get(`/v1/places/${id}/reports`, { schema: [report] });
export const getPlaceReportsV2 = ({ placeId, params }) => Api.get(`/v1/places/${placeId}/reports`, { params });
export const postReportWitness = (id, payload) => post(`/v1/reports/${id}/witness`, payload, { schema: report });
export const resolveReport = ({ id, payload }) => post(`/v1/reports/${id}/resolve`, payload);
export const createReport = (equipmentId, payload) =>
   post(`/v1/equipments/${equipmentId}/reports`, payload, { schema: report });
export const createReportEvent = (id, payload) => post(`/v1/reports/${id}/events`, payload, { schema: reportEvent });
